import { useSelector } from "react-redux";
import { RootState } from "State/store";

export const useSortValue = () =>
  useSelector((state: RootState) => state.sort).value;
